import { RefreshCw, X } from "lucide-react";
import { useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

import { useServiceWorkerUpdate } from "./serviceWorkerUpdate";

/** Tells the user a new version was deployed and lets them reload into it. */
export const UpdatePrompt = () => {
  const translate = useTranslate();
  const { isUpdateAvailable, applyUpdate, dismissUpdate } =
    useServiceWorkerUpdate();

  if (!isUpdateAvailable) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-2 top-2 z-50 mx-auto flex max-w-md items-center gap-3 rounded-lg border bg-background p-3 shadow-lg"
    >
      <p className="flex-1 text-sm">{translate("crm.pwa.update_available")}</p>
      <Button size="sm" onClick={() => void applyUpdate()}>
        <RefreshCw />
        {translate("crm.pwa.reload")}
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="size-8"
        aria-label={translate("crm.pwa.dismiss")}
        onClick={dismissUpdate}
      >
        <X />
      </Button>
    </div>
  );
};
